import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=40446afc&"
import script from "./suggestions.vue?vue&type=script&lang=js&"
export * from "./suggestions.vue?vue&type=script&lang=js&"
import style0 from "./suggestions.vue?vue&type=style&index=0&id=40446afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports